export const OpenLoanTypeList = [
  '',
  undefined,
  'installment',
  'oec',
  'cso',
  'cnu_bank_partnership_ccb_loc',
] as const;

export type CurrentLoanTypeT = typeof OpenLoanTypeList[number];

export type SimplifiedAccountInfoT = {
  account_id: number;
  current_loan_type: CurrentLoanTypeT;
  first_name: string;
  last_name: string;
  show_fee_saver_status: boolean;
  due_date_adjustment_eligible?: boolean;
  open_loan_number?: string;
  open_loan_type?: CurrentLoanTypeT;
};

export const isLoanTypeBloc = (loanType: CurrentLoanTypeT) => loanType && loanType === 'cnu_bank_partnership_ccb_loc';
export const isLoanTypeLoc = (loanType: CurrentLoanTypeT) => loanType && loanType === 'oec';
export const isLoanTypeInstallment = (loanType: CurrentLoanTypeT) => loanType && loanType === 'installment';

export const isOpenLoan = (loanType?: CurrentLoanTypeT) => !!loanType;

export const productType = (loanType: CurrentLoanTypeT) => ((loanType && loanType === 'oec')
  ? 'Line of Credit'
  : 'Installment');

export type CurrentLoanInfoT = {
  automatic_payment_eligible: boolean;
  due_date_adjustment_eligible: boolean;
  gov_law_state_cd: string;
  id: number;
  loan_type_cd: CurrentLoanTypeT;
};

export type BlocActiveLoanInfoT = {
  automatic_payment_eligible: boolean;
  due_date_adjustment_eligible: boolean;
  gov_law_state_cd: string;
  id: number;
  open_loan_number: string;
  open_loan_type: CurrentLoanTypeT;
};

export type LoanTypeT = 'installment' | 'oec';
